module.exports = __webpack_public_path__ + "static/img/yongsan-development.52c0134.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/yongsan-development.jpg
// module id = 94XF
// module chunks = 0